/** Types for EuFMD Impact MEL home */

export type StatusBand = 'on_track' | 'in_progress' | 'behind' | 'no_data';

export interface FocusObjectiveSummary {
  id: number;
  name: string;
  management?: string;
  target_count: number;
  targets_with_data: number;
  avg_progress_pct: number | null;
  on_track: number;
  in_progress: number;
  behind: number;
  no_data: number;
}

export interface KeyAreaSummary {
  id: number;
  name: string;
  short_label: string;
  focus_objective_id: number;
  management?: string;
  target_count: number;
  targets_with_data: number;
  avg_progress_pct: number | null;
  on_track: number;
  in_progress: number;
  behind: number;
  no_data: number;
}

export interface TargetsSummary {
  overall_progress_pct: number | null;
  target_count: number;
  targets_with_data: number;
  status_counts: Record<StatusBand, number>;
  focus_objectives: FocusObjectiveSummary[];
  key_areas: KeyAreaSummary[];
}

export interface MemberNation {
  iso3: string;
  name: string;
  is_member: number | boolean;
  is_neighbour?: number | boolean;
  region_group?: string;
}

export interface EvidenceActivitySnippet {
  title: string;
  activity_type?: string;
  date?: string | null;
  participants?: number | null;
  location?: string | null;
}

export interface EvidenceByCountry {
  iso3: string;
  country_name?: string;
  activity_count: number;
  participants_sum: number;
  activity_types: Record<string, number>;
  activities?: EvidenceActivitySnippet[];
}

export interface TargetsMapData {
  membership: MemberNation[];
  evidence_by_country: EvidenceByCountry[];
  evidence_rows: any[];
  filters: Record<string, unknown>;
}

export interface CountryActivity {
  evidence_id: number;
  iso3: string;
  country_name?: string;
  location_text?: string | null;
  countries_json?: string[] | null;
  target_id: string;
  indicator?: string;
  key_area_id?: number;
  key_area?: string;
  focus_objective_id?: number;
  focus_objective?: string;
  activity_type: string;
  title?: string;
  narrative?: string | null;
  start_date?: string;
  end_date?: string | null;
  activity_year?: number | null;
  activity_month?: number | null;
  metrics_json?: Record<string, unknown> | null;
  source_ref?: string;
  page_ref?: string | null;
  period_label?: string;
  period_year?: number | null;
  period_half?: number | null;
}

export interface CountryDrawerData {
  country: MemberNation & { iso3: string; name: string };
  activities: CountryActivity[];
  linked_targets: any[];
  key_area_id?: number | null;
  empty: boolean;
  empty_message?: string | null;
}

export interface KeyAreaTarget {
  target_id: string;
  indicator?: string;
  target_description?: string;
  result_to_date?: number | string | null;
  program_target?: number | string | null;
  progress_pct?: number | null;
  progress_pct_raw?: number | null;
  status_band?: StatusBand | string;
  aggregation?: 'sum' | 'latest' | string;
  latest_period_label?: string | null;
}

export interface KeyAreaTargetsResponse {
  key_area: {
    id: number;
    name: string;
    short_label: string;
    focus_objective_id: number;
    focus_objective?: string;
    avg_progress_pct: number | null;
    target_count: number;
    targets_with_data: number;
  };
  targets: KeyAreaTarget[];
}

export const MEL_TEAL = '#15736d';
export const MEL_TEAL_DARK = '#0f5b57';
/** Member nations — solid dark green choropleth */
export const MEL_MEMBER_FILL = '#0f5b57';
export const MEL_MEMBER_FILL_STRONG = '#0a4743';
/** Neighbouring countries (eufmd_nc) */
export const MEL_NEIGHBOUR_FILL = '#9ec5c0';
export const MEL_EVIDENCE_FILL = '#0d9488';
